import { render, staticRenderFns } from "./EditEvents.vue?vue&type=template&id=27a51d75"
import script from "./EditEvents.vue?vue&type=script&lang=js"
export * from "./EditEvents.vue?vue&type=script&lang=js"
import style0 from "./EditEvents.vue?vue&type=style&index=0&id=27a51d75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports